function resize() {
    const resize = () => {
        let nav = document.querySelector("#navTop").offsetHeight;
        let homeContainer = document.querySelector("#home");
        let margin = (nav + "px").toString();
        let landingPage = document.querySelector("#landingPageDark");
        let main = document.querySelector("#main");
        let blog = document.querySelector(".blogWrapper");

        if(homeContainer){
            homeContainer.style.paddingTop = margin;
        }
        if(landingPage){
            landingPage.style.paddingTop = margin;
        }
        if(main){
            main.style.paddingTop = margin;
        }
        if(blog){
            blog.style.paddingTop = margin;
        }
    }

    window.addEventListener("load", resize);
    window.addEventListener("resize", resize);
}

export default resize();
